import { createClient } from '@supabase/supabase-js';

const url = process.env.IB_SUPABASE_URL;
const anonKey = process.env.IB_SUPABASE_ANON_KEY;

// ไม่มี env = โหมด MOCK (ดู UI ด้วยข้อมูลจำลอง ก่อน schema deploy)
export const MOCK = !url || !anonKey;

// PUBLIC BRIDGE: schema inbound ยัง expose ไม่ติด → อ่าน/เขียนผ่าน public.ib_* แทน
// เมื่อ inbound expose ได้ → ลบ IB_PUBLIC_BRIDGE (redeploy) กลับไปใช้ inbound ตรงๆ
export const BRIDGE = process.env.IB_PUBLIC_BRIDGE === '1';

export const supabase = MOCK ? null
  : createClient(url, anonKey, { db: { schema: BRIDGE ? 'public' : 'inbound' } });
// ตาราง public (profiles / shim) ต้องเรียกผ่าน client แยก schema
export const supabasePublic = MOCK ? null : createClient(url, anonKey);

// map ชื่อ table/view/rpc ตามโหมด (bridge = prefix ib_)
export const T = (name) => (BRIDGE ? `ib_${name}` : name);

// schema inbound ยังไม่ถูก expose ผ่าน REST (PGRST106) — ระหว่างรอ Supabase restart
export const isSchemaPending = (e) =>
  e?.code === 'PGRST106' || /schema:\s*inbound|inbound.*expose/i.test(e?.message ?? String(e ?? ''));
